'use strict';

angular.module('theme').service('TrackerService', function ($window, $httpParamSerializer, $cookies, md5, CUSTOMER, LANG) {

	this.customEvent = function(eventType, category, action, label) {
		var data = {
			'event': eventType,
			'category': category,
			'action': action
		};

		if (label) {
			data['label'] = label;
		}

		dataLayer.push(data);
	};

	this.customerEvent = function(customer) {
		if (!customer) { return; }

		var today = moment();

		if (customer.matkasseFirstBaseDate && customer.matkasseFirstBaseDate !== '') {
			var weekSinceFirstDelivery = today.diff(moment(customer.matkasseFirstBaseDate), 'weeks');
		}

		if (customer.matkasseLastBaseDate && customer.matkasseLastBaseDate !== '') {
			var weeksSinceLastDelivery = today.diff(moment(customer.matkasseLastBaseDate), 'weeks');
		}

		var data = {
			'userId': customer.id,
			'customerCategory': customer.category,
			'campaignCode': customer.campaignCode,
			'noOfDeliveries': customer.numberOfMatkasseDeliveries,
			'weekSinceFirstDelivery': weekSinceFirstDelivery >= 0 ? weekSinceFirstDelivery : undefined,
			'weeksSinceLastDelivery': weeksSinceLastDelivery >= 0 ? weeksSinceLastDelivery : undefined
		};

		dataLayer.push(data);
	};

	this.productImpressionsEvent = function(impressions) {
		dataLayer.push({
			'event': 'view_item_list',
			'ecommerce': {
				'currency': 'SEK',
				'items': impressions
			}
		});
	};

	this.addToCartEvent = function(item) {
		dataLayer.push({ 'ecommerce': null}); // Clear the previous ecommerce object.
		dataLayer.push({
			'event': 'add_to_cart',
			'value' : item[0].price,
			'ecommerce': {
				'currency': 'SEK',
				'items': item
			}
		});
	};

	this.addToViewEvent = function(item) {
		dataLayer.push({ 'ecommerce': null}); // Clear the previous ecommerce object.
		dataLayer.push({
			'event': 'view_item',
			'value' : item[0].price,
			'ecommerce': {
				'currency': 'SEK',
				'items': item
			}
		});
	};

	this.ecommercePurchase = function (cart, cartProducts, summary) {
		dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.

		var voucher = '';

		if (cart.giftvoucher && cart.giftvoucher.id !== '') {
			voucher = cart.giftvoucher.id;
		}

		if (cart.discountcode.status === '1' && cart.discountcode.id !== '') {
			voucher = cart.discountcode.id;
		}

		dataLayer.push({
			'event': 'purchase',
			'ecommerce': {
				'currency': 'SEK',
				'purchase': {
					'actionField': {
						'id': cart.customer.id,
						'revenue': cart.total.amount,
						'tax': cart.total.amount * 0.25,
						'shipping': 0,
						'coupon': voucher
					},
					'products': cartProducts
				}
			},
			'ci': 16644,
			'ti': cart.customer.id,
			'a': cart.total.amount,
			'r': cart.total.amount,
			'pn': cart.article.type,
			'iv': 'Beställning av matkasse',
			'z': summary && summary['shipping_address'] ? summary['shipping_address']['postal_code'] : '',
			'pr': voucher,
			'c': 'SV',
			'cur': 'SEK'
		});

		// Daisycon tracking data
		var data = {

		};

		dataLayer.push(data);
	};

	this.ecommerceEvent = function (type, data) {
		dataLayer.push({
			'event': type,
			'ecommerce': data
		});
	};

	var currency = LANG === 'nb' ? 'NOK' : 'SEK';

	this.addToCart = function (product, amount) {
		fbq('track', 'AddToCart', {
			content_name: product.type
		});

		pintrk('track', 'addtocart', {
			value: amount,
			order_quantity: 1,
			currency: 'SEK',
			product_id: product.type
		});

	};

	this.checkout = function (cart) {
		var product = cart.article;

		fbq('track', 'InitiateCheckout', {
			content_type: 'product',
			content_name: product.type,
			content_ids: product.id,
			num_items: 1,
			value: product.price,
			currency: currency
		});
	};

	this.purchase = function (cart) {
		var article = cart.article;

		pintrk('track', 'checkout', {
			value: cart.total.amount,
			order_quantity: 1,
			currency: 'SEK',
			product_id: article.type
		});

		fbq('track', 'Purchase', {
			content_type: 'product',
			content_name: article.type,
			content_ids: [article.id],
			value: cart.total.amount,
			num_items: 1,
			currency: currency
		});

		addrevenue_event('Purchase', {
			'value': cart.total.amount,
			'currency': 'SEK',
			'orderId': cart.customer.id
		});

		/*

		var transaction = {
			id: cart.customer.id,
			revenue: cart.total.amount,
			currency: currency
		};

		var item = {
			id: cart.customer.id,
			name: article.type,
			price: article.price,
			quantity: 1
		};

		ga('ecommerce:addTransaction', transaction);
		ga('ecommerce:addItem', item);
		ga('ecommerce:send');

		ga('ds.ecommerce:addTransaction', transaction);
		ga('ds.ecommerce:addItem', item);
		ga('ds.ecommerce:send');

		if (LANG === 'sv') {
			this.partnerAd(cart);
			this.adviralMedia(cart);
		}
		*/
	};

	this.adTractionGiftcard = function(cart) {
		ADT.Tag.t = 3;
		ADT.Tag.c = 'SEK';
		ADT.Tag.tp = 1288112396;
		ADT.Tag.am = cart.total.amount;
		ADT.Tag.ti = cart.customer.id;
		ADT.Tag.xd = md5.createHash(_.toLower(CUSTOMER.email));
		ADT.Tag.cpn = cart.discountcode.id;
		ADT.Tag.doEvent();
	};

	this.adTraction = function (cart) {

		// New tracking
		ADT.Tag.t = 3;
		ADT.Tag.c = 'SEK';
		ADT.Tag.tp = 925414129;
		ADT.Tag.am = cart.total.amount;
		ADT.Tag.ti = cart.customer.id;
		ADT.Tag.xd = md5.createHash(_.toLower(CUSTOMER.email));
		ADT.Tag.cpn = cart.discountcode.id;
		ADT.Tag.doEvent();

		// Old tracking
		var params = {
			t: 3,
			tk: 1,
			trt: 4,
			am: cart.total.amount,
			c: currency,
			ti: cart.customer.id,
			cpn: cart.discountcode.id,
			xd: md5.createHash(_.toLower(CUSTOMER.email))
		};

		if (LANG === 'nb') {
			params.ap = '1150086645';
			params.tp = '1150086965';
		} else {
			params.ap = '925412209';
			params.tp = '925414129';
		}

		var trackingImg = document.createElement('img');
		trackingImg.src = 'https://track.adtraction.com/t/t?' + $httpParamSerializer(params);
		document.body.appendChild(trackingImg);

	};

	this.adviralMedia = function (cart) {
		var trackingIframe = document.createElement('iframe');
		trackingIframe.src = 'https://tracking.adviralmedia.com/pixel/1049/?r=' + cart.customer.id;
		trackingIframe.style = 'width:0;height:0;';
		trackingIframe.frameBorder = 0;
		document.body.appendChild(trackingIframe);
	};

	this.partnerAd = function (cart) {
		var trackingImg = document.createElement('img');
		trackingImg.src = 'https://www.partner-ads.com/se/leadtrack.php?programid=6513&type=lead&uiv=' + cart.customer.id + '&transactionTotal=' + cart.total.amount;
		document.body.appendChild(trackingImg);
	};

});
